import React from "react";
import { View, Dimensions } from "react-native";

import AppConfig from "../../../config/AppConfig";
import Header from "../common/header";
import appStyles from "../../appStyles";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

export default class AppointmentPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
  }

  goBack = () => {
    this.controller.goBack();
  };

  render() {
    const Element = "div";
    const link = this.controller?.state?.settings?.guide_calendly_link;
    const src = link || AppConfig.CALENDLY_LINK;

    const width = Math.min(WIDTH, AppConfig.MAX_WIDTH);
    const height = HEIGHT - 130;
    const code = `<iframe src=${src} frameBorder=0 width=${width} height=${height} />`;

    return (
      <View style={appStyles.container}>
        <Header
          title="Schedule Guide Call"
          subTitle="Stay accountable & get support on your progress"
          goBack={this.goBack}
          hideAvatar
          controller={this.controller}
        />

        <View
          style={{
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <Element
            src={null}
            children={null}
            style={{ maxWidth: "100%" }}
            dangerouslySetInnerHTML={{ __html: code }}
          />
        </View>
      </View>
    );
  }
}
